@if (isAuthor && (currentObject$ | async); as currentObject) {
	<ada-container
		#AuthoringToolbar
		backgroundHighlight="background"
		id="AuthoringToolbar"
		verticalAlignmentOfChildren="Middle"
		colCount="{{ 0 }}"
		padding="{{ ui.Spacing.SPACING_MEDIUM }} {{ ui.Spacing.SPACING_LARGE }}"
	>
		<!-- Authoring -->
		<ada-push-button
			icon="faCaretDown"
			iconPosition="right"
			text="Authoring"
			[adaMenuTrigger]="AuthoringMenu"
			[adaMenuTriggerData]="currentObject"
		/>
		<ada-menu
			#AuthoringMenu
			[controller]="authoringMenuController"
		/>

		<!-- Approving -->
		@if (isApprover) {
			<ada-push-button
				icon="faCaretDown"
				iconPosition="right"
				text="Approving"
				[adaMenuTrigger]="ApprovingMenu"
				[adaMenuTriggerData]="currentObject"
			/>
		}
		<ada-menu
			#ApprovingMenu
			[controller]="approvingMenuController"
		/>
		<ada-container
			horizontalAlignment="right"
			justifyContent="flex-end"
			verticalAlignmentOfChildren="Middle"
			width="auto"
			[colCount]="0"
			[colSpan]="0"
		>
			<!-- Keyboard Shortcut Icon -->
			<ada-icon
				#KeyboardShortcutDisplay
				color="primary"
				icon="faKeyboard"
				id="KeyboardShortcutDisplay"
				size="lg"
				tooltip="View MAS Supported Hotkeys"
				[attr.title]="'Keyboard Shortcuts'"
				padding="0px {{ ui.Spacing.SPACING_MEDIUM }}"
				(click)="keybindInfoClick($event)"
			/>

			<!-- Create new menu -->
			@if (createChildOptions?.length) {
				<ada-push-button
					icon="faCaretDown"
					iconPosition="right"
					look="outline"
					text="Create New"
					[adaMenuTrigger]="NewChildMenu"
					[isDisabled]="(currentObject$ | async).objectId === 0"
				/>
				<ada-menu
					#NewChildMenu
					[isDisabled]="(currentObject$ | async).objectId === 0"
					[items]="currentObject$ | async | adaCreateChildMenus: createChildOptions"
				/>
			}
		</ada-container>
	</ada-container>
}

<ada-overlay
	#CommentOverlay
	id="CommentOverlay"
	title="Comment"
	(submit)="submitCommentedResponse()"
>
	<ada-container
		*adaTemplateMarker
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="ui.Spacing.SPACING_LARGE"
	>
		<ada-text
			content="Reasoning"
			[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
		/>
		<ada-container
			[colCount]="2"
			[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		>
			<ada-input
				#CommentInput
				id="CommentInput"
				type="textarea"
				[debounce]="100"
				[outputDateAsInteger]="true"
				[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
				[showAsFullWidth]="true"
				(valueChange)="setComment($event)"
			/>
		</ada-container>
	</ada-container>
</ada-overlay>
